import request from '@/utils/http';

export const getDepositLists = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/queryOfDeposit`,
        method: 'post',
        data
    });
};

// export const getBusinessTypeLists = (params) => {
//     return request({
//         url: `/api-mdm/mdmDataDictionaryDetails?dictCode=BID_BUSINESS_TYPE`,
//         method: 'get',
//         params
//     });
// };

// export const getMdnPayType = (params) => {
//     return request({
//         url: `/api-mdm/mdmDataDictionaryDetails?dictCode=SYS_BMS_DEPOSIT_PAY_TYPE`,
//         method: 'get',
//         params
//     });
// };

// export const getMdnDepositStatus = (params) => {
//     return request({
//         url: `/api-mdm/mdmDataDictionaryDetails?dictCode=SYS_BMS_DEPOSIT_AP_STATUS`,
//         method: 'get',
//         params
//     });
// };

// 根据code从数据字典获取
export const getDictionaryDetailByCode = (params) => {
    return request({
        url: `/api-mdm/dictionaryDetail/dict`,
        method: 'get',
        params
    });
};
